<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="facilityFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                facilityFileForm: () => import('../forms/FacilityFileForm'),
                headers: [
                    { text: 'Facility', value: 'facilityId', table: 'facilities', form: () => import('../forms/FacilityForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    facilities: [],
                    files: [],
                    items: []
                },
                sorting: [
                    { column: "facilityId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'facilityFiles',
                editPageName: 'facilityFile',
                apiMethod: 'FacilityFiles',
                claimName: 'FacilityFiles',
                formTitle: 'Facility File',
                excelTitle: 'Facility Files',
                hasEditPage: false,
            }
        },
    };
</script>
